import React from 'react';
import { CellContext } from '@tanstack/react-table';

import { AdaptiveTableCell } from '@components/common';
import Actions from '@components/common/Actions';

import { IBranchTable } from '@interfaces/cmModule/configurationComparison';

import { columnSizes } from '@constants/table';

import styles from '@components/common/Table/Table.module.scss';

interface IColumns {
	openTableBranch: (data: IBranchTable) => void;
	isMavenirVendor?: boolean;
	isAwtgRanVendor?: boolean;
}

export const getColumns = ({
	openTableBranch,
	isMavenirVendor,
	isAwtgRanVendor,
}: IColumns) => ([
	{
		header: isAwtgRanVendor ? 'Data Model Path' : 'Branch',
		accessorKey: isAwtgRanVendor ? 'dataModelPath' : 'distName',
		enableSorting: false,
		cell: ({ getValue }: CellContext<any, any>) => {
			const value = getValue();

			return <AdaptiveTableCell text={value} />;
		},
	},
	{
		header: () => <div className={styles.centerColumnHeader}>Total</div>,
		accessorKey: 'totalNumber',
		enableSorting: true,
		cell: ({ row }: CellContext<any, any>) => {
			const totalNumber = isAwtgRanVendor
				? row.original?.totalNumber
				: row.original?.metadata?.totalNumber;

			return (
				<AdaptiveTableCell
					isCentered
					text={totalNumber}
				/>
			);
		},
	},
	{
		header: 'Increased',
		isHidden: isMavenirVendor || isAwtgRanVendor,
		accessorKey: 'increasedNumber',
		cell: ({ row }: CellContext<any, any>) => {
			const increasedNumber = row.original?.metadata?.increasedNumber;

			return (
				<AdaptiveTableCell
					className={styles.greenCell}
					text={increasedNumber}
				/>
			);
		},
	},
	{
		header: 'Decreased',
		isHidden: isMavenirVendor || isAwtgRanVendor,
		accessorKey: 'decreasedNumber',
		cell: ({ row }: CellContext<any, any>) => {
			const decreasedNumber = row.original?.metadata?.decreasedNumber;

			return (
				<AdaptiveTableCell
					className={styles.redCell}
					text={decreasedNumber}
				/>
			);
		},
	},
	{
		header: 'Missing',
		isHidden: isMavenirVendor || isAwtgRanVendor,
		accessorKey: 'missingNumber',
		cell: ({ row }: CellContext<any, any>) => {
			const missingNumber = row.original?.metadata?.missingNumber;

			return (
				<AdaptiveTableCell
					className={styles.grayCell}
					text={missingNumber}
				/>
			);
		},
	},
	{
		header: 'Others',
		isHidden: isMavenirVendor || isAwtgRanVendor,
		accessorKey: 'otherNumber',
		cell: ({ row }: CellContext<any, any>) => {
			const otherNumber = row.original?.metadata?.otherNumber;

			return (
				<AdaptiveTableCell
					className={styles.orangeCell}
					text={otherNumber}
				/>
			);
		},
	},
	{
		header: () => <div className={styles.centerColumnHeader}>Actions</div>,
		accessorKey: 'Actions',
		enableSorting: false,
		size: columnSizes.size135,
		cell: ({ row }: CellContext<any, any>) => {
			const handleOpenTableBranch = () => {
				openTableBranch(row.original);
			};

			return (
				<Actions
					isCentered
					isOpenModal
					openModalHandler={handleOpenTableBranch}
				/>
			);
		},
	},
]);
